import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Loader from "designs/v1/pages/ModifyKyc/components/Loader";
import ValidatePan from "./ValidatePan";
import DematUccForm from "../DematUccForm";
import PanProof from "./PanProof";
import AddressProof from "./AddressProof";
import PersonalDetails from "./PersonalDetails";
import IncomeProof from "./IncomeProof";
import VisualVerification from "./VisualVerification";
import ESignature from "./ESignature";
import {
  reactivateUccDematApi,
  reactivateForSendPdfApi,
  reactivateForEsignApi,
  getReactivateStageApi,
} from "designs/v1/pages/ModifyKyc/services";

const Reactivation = ({ stageScreen, setStageScreen }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState("");
  const [activeUserDetail, setActiveUserDetail] = useState(null);
  const { hasReactivationProof } = useSelector((state) => state.theme);

  const getReactivateStage = async (payload) => {
    setIsLoading(true);
    try {
      const resp = await getReactivateStageApi(payload);
      let stageList = resp.data?.data?.RekycRequests_flow_status || [];
      let pageName = 0;
      for (let index = 0; index < stageList.length; index++) {
        const element = stageList[index];
        if (pageName === 0) {
          if (element?.personal_details?.status === 0) {
            pageName = "PersonalDetails";
          } else if (element?.visual_verification?.status === 0) {
            pageName = "VisualVerification";
          } else if (element?.income_proof_details?.status === 0) {
            pageName = "IncomeProof";
          } else if (
            element?.personal_details?.status === 1 &&
            element?.visual_verification?.status === 1 &&
            element?.income_proof_details?.status === 1
          ) {
            pageName = "ValidatePan";
          }
        }
        setStep(pageName);
        setActiveUserDetail((prev) => ({
          ...prev,
          request_number: payload.doc_name,
        }));
        setIsLoading(false);
      }
    } catch {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const doc_name = window.sessionStorage.getItem("doc_name");
    if (!doc_name) {
      return setStep("ValidatePan");
    }
    const payload = {
      request_type: "Reactivation",
      doc_name,
    };
    getReactivateStage(payload);
  }, []);

  const handleBack = () => {
    setStep("ValidatePan");
  };

  const handleUccDemat = async (formVal) => {
    setIsLoading(true);
    const payload = {
      request_type: "Reactivation",
      document_name: activeUserDetail?.request_number,
      ...formVal,
    };
    try {
      const resp = await reactivateUccDematApi(payload);
      console.log("resp", resp);
      if (hasReactivationProof === "Yes") {
        toast.success("Trading & Demat Account details saved successfully.");
        setStep("PanProof");
        setIsLoading(false);
      } else {
        try {
          const payload = {
            request_type: "Reactivation",
            doc_name: activeUserDetail?.request_number,
          };
          await Promise.all([
            reactivateForSendPdfApi(payload),
            reactivateForEsignApi(payload),
          ]);
          setIsLoading(false);
          setStep("ESignature");
          toast.success("Request for Esign submitted successfully.");
        } catch (error) {
          setIsLoading(false);
          const { data } = error.response || {};
          toast.error(data.message || "Internal server error!.");
        }
      }
    } catch (error) {
      setIsLoading(false);
      const { data } = error.response || {};
      toast.error(data.message || "Internal server error!.");
    }
  };

  const getStepScreen = (step) => {
    let html = null;
    switch (step) {
      case "ValidatePan":
        html = (
          <ValidatePan
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setActiveUserDetail={setActiveUserDetail}
          />
        );
        break;
      case "DematUccForm":
        html = (
          <DematUccForm
            activeUserDetail={activeUserDetail}
            isLoading={isLoading}
            handleBack={handleBack}
            handleSubmit={handleUccDemat}
          />
        );
        break;
      case "PanProof":
        html = (
          <PanProof
            activeUserDetail={activeUserDetail}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setStep={setStep}
          />
        );
        break;
      case "AddressProof":
        html = (
          <AddressProof
            activeUserDetail={activeUserDetail}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setStep={setStep}
          />
        );
        break;
      case "PersonalDetails":
        html = (
          <PersonalDetails
            activeUserDetail={activeUserDetail}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setStep={setStep}
          />
        );
        break;
      case "IncomeProof":
        html = (
          <IncomeProof
            activeUserDetail={activeUserDetail}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setStep={setStep}
          />
        );
        break;
      case "VisualVerification":
        html = (
          <VisualVerification
            activeUserDetail={activeUserDetail}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setStep={setStep}
          />
        );
        break;
      case "ESignature":
        html = <ESignature setStageScreen={setStageScreen} />;
        break;
      default:
        break;
    }
    return html;
  };
  return (
    <React.Fragment>
      {isLoading && <Loader />}
      {getStepScreen(step)}
    </React.Fragment>
  );
};

export default Reactivation;
